export default "__VITE_ASSET__BzX2WTA0__"